import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _noop from 'lodash/noop';
import _get from 'lodash/get';
import { DatePicker } from 'antd';
import { defaultMemoize } from 'reselect';
import cx from 'classnames';
import styles from './dateRange.module.scss';
import getPresetList from './presetList';
import PRESET_ID from './constants/dateRange.presetIds';
import PRESET_LABEL_MAP from './constants/dateRange.presetLabels';
var RangePicker = DatePicker.RangePicker;
var DATE_FORMAT = 'MMM DD, YYYY';
var DEFAULT_DATE_RANGE = getPresetList()[PRESET_ID.CUSTOM];
var DateRange = /*#__PURE__*/function (_React$Component) {
  _inherits(DateRange, _React$Component);
  var _super = _createSuper(DateRange);
  function DateRange(props) {
    var _this;
    _classCallCheck(this, DateRange);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getPresetIndex", defaultMemoize(function (values, additional) {
      var presetIndex;
      if (!_isEmpty(values)) {
        presetIndex = 5;
      }
      var _this$props = _this.props,
        defaultPreset = _this$props.defaultPreset,
        presetId = _this$props.presetId;
      var selectedPreset = additional && Array.isArray(additional) ? additional[0] : defaultPreset;
      presetIndex = _findIndex(presetId, function (key) {
        return key === selectedPreset;
      });
      return presetIndex;
    }));
    _this.rangePicker = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(DateRange, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        presetId = _this$props2.presetId,
        defaultPreset = _this$props2.defaultPreset;
      this.selectedDates = presetId[defaultPreset];
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevValues = prevProps.values;
      var values = this.props.values;
      var clearHoverValue = _get(this.rangePicker, 'current.picker.clearHoverValue');
      if (!_isEqual(prevValues, values) && _isEmpty(values) && typeof clearHoverValue === 'function') {
        clearHoverValue();
      }
    }
  }, {
    key: "getPresets",
    value: function getPresets() {
      var presetId = this.props.presetId;
      var presetList = getPresetList();
      return presetId.reduce(function (acc, val) {
        // eslint-disable-next-line
        acc[PRESET_LABEL_MAP[val]] = presetList[val];
        return acc;
      }, {});
    }
  }, {
    key: "dateRender",
    value: function dateRender(current) {
      return /*#__PURE__*/React.createElement("div", {
        className: "ant-calendar-date ".concat(styles.customIndividualDate)
      }, current.date());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        onChange = _this$props3.onChange,
        defaultValue = _this$props3.defaultValue,
        getValueFromProps = _this$props3.getValueFromProps,
        values = _this$props3.values,
        allowClear = _this$props3.allowClear,
        noLabel = _this$props3.noLabel,
        additional = _this$props3.additional,
        disabled = _this$props3.disabled,
        disabledDate = _this$props3.disabledDate;
      var presetIndex = this.getPresetIndex(values, additional);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RangePicker, _extends({
        ranges: this.getPresets(),
        ref: this.rangePicker,
        onChange: onChange,
        separator: "-",
        defaultValue: defaultValue,
        className: cx(styles.datePickerCustom, _defineProperty({}, styles.datePickerCustomNoLabel, noLabel)),
        dropdownClassName: cx(styles.rangePickerCustom, _defineProperty({}, styles.rangePickerCustomNoLabel, noLabel), "rangePickerCustom-".concat(presetIndex)),
        format: DATE_FORMAT,
        allowClear: allowClear,
        dateRender: this.dateRender,
        disabled: disabled,
        disabledDate: disabledDate
      }, getValueFromProps && {
        value: values
      })));
    }
  }]);
  return DateRange;
}(React.Component);
DateRange.propTypes = {
  open: PropTypes.bool.isRequired,
  container: PropTypes.instanceOf(Element).isRequired,
  defaultPreset: PropTypes.string,
  defaultFallBack: PropTypes.string.isRequired,
  presetId: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.array,
  allowClear: PropTypes.bool,
  noLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledDate: PropTypes.func
};
DateRange.defaultProps = {
  defaultValue: DEFAULT_DATE_RANGE,
  allowClear: false,
  noLabel: false,
  defaultPreset: PRESET_ID.CUSTOM,
  disabled: false,
  disabledDate: _noop
};
export default DateRange;